import { useCallback, useState } from 'react';
import { useToast } from '@/components/ui/Toast';
import { useDesk } from './DeskData';

export const errText = (e: any): string => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  if (Array.isArray(d?.missing) && d.missing.length)      // e.g. a strategy asked for before the answers it needs
    return `Answer these first in Your business: ${d.missing.map((q: any) => q.label || q.text).filter(Boolean).join(', ')}.`;
  if (typeof d?.message === 'string') return d.message;
  return e?.message || 'Something went wrong. Please try again.';
};

/**
 * Runs one owner action: marks it busy, shows the outcome in plain words, then reloads the desk
 * so every part of the page (and the shell's needs/jobs) reflects it. Returns the result, or
 * null when it failed.
 */
export const useAct = () => {
  const { refresh } = useDesk();
  const { toast } = useToast();
  const [busy, setBusy] = useState<string | null>(null);
  const act = useCallback(async <T,>(key: string, fn: () => Promise<T>, ok?: string, warnings?: (r: T) => string[] | undefined): Promise<T | null> => {
    setBusy(key);
    try {
      const r = await fn();
      (warnings?.(r) || []).forEach(w => toast.warning(w));
      if (ok) toast.success(ok);
      await refresh();
      return r;
    } catch (e) {
      toast.error(errText(e));
      return null;
    } finally {
      setBusy(null);
    }
  }, [refresh, toast]);
  return { busy, act };
};
